<template>
  <div class="container">
    <card>
      <div class="card-bpdy">
        <h2>{{$t('Access_to_this_page_is_restricted')}}</h2>
        <p>{{$t('Please_check_with_the_site_admin_if_you_believe_th')}}</p>
      </div>
    </card>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" >
</style>